import { Dayjs } from "dayjs";
import {
  defaultBreakStartTime,
  defaultEndTime,
  defaultStartTime,
} from "../Forms/OpeningTimes/openingTimeDateUtils";
import { WeekDays, WeekDaysFlags } from "./WeekDays";

export default interface OpeningTime {
  Id: number;
  ParentId: number;
  WeekDays: WeekDays[];
  StartTime: Dayjs;
  EndTime: Dayjs;
  HasBreak: boolean;
  BreakStartTime: Dayjs | undefined;
  BreakDuration: string | undefined;
  IsNew: boolean;
}

export interface OpeningTimeDto {
  Id: number;
  ParentId: number;
  OpeningDays: WeekDaysFlags;
  OpeningHour: string;
  ClosingHour: string;
  HasBreak: boolean;
  BreakStartTime: string | undefined;
  BreakDuration: number;
}

export const defaultOpeningTime: OpeningTime = {
  Id: 0,
  ParentId: 0,
  WeekDays: [
    WeekDays.Monday,
    WeekDays.Tuesday,
    WeekDays.Wednesday,
    WeekDays.Thursday,
    WeekDays.Friday,
  ],
  StartTime: defaultStartTime(),
  EndTime: defaultEndTime(),
  BreakStartTime: defaultBreakStartTime(),
  BreakDuration: "00:30",
  HasBreak: false,
  IsNew: true,
};

export const BREAK_START = "Break Start";
export const OPENING_TIME = "Opening Time";
export const CLOSING_TIME = "Closing Time";
